import api from './axios';

export const reviewsApi = {
  publicList: (limit = 6) => api.get('/reviews', { params: { limit } }).then((r) => r.data),
};
